module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "head",
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ack.htm"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/fm1.htm"
    }
  }, [_vm._v("Welcome to Our Kitchen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("Breakfast for Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("One-Pot Wonders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("A Big Pot of Whole Grains")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_vm._v("Stir-Fries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("Rice and Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_vm._v("A Big Bowl of Pasta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_vm._v("The Meat Chapter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_vm._v("Breaking Down a Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_vm._v("Fire Up the Grill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_vm._v("Buffets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_vm._v("Sweetness at the End of the Evening")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/res.htm"
    }
  }, [_vm._v("Resources")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-349bca82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 75
// module chunks = 0